import axios from "axios";

import globalRouter from "../../src/components/globalRouter";

const api = axios.create({

    baseURL:(process.env.REACT_APP_API_URL || "__BACKEND_API__")+"/api/v1",
});



export default api


api.interceptors.response.use((response) => {
    return response
},function (error) {
    switch (error.response?.status) {
        case 401:
            // Token invalidated - clear cookies and redirect
            document.cookie = "tokenClient=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            
            // Check if we're on admin routes
            if (window.location.pathname.startsWith('/admin')) {
                window.location.href = '/admin/login';
            } else {
                window.location.href = '/login';
            }
            break;
        case 403:
            if (globalRouter.navigate) {
                globalRouter.navigate('/403');
            }
            break;
        default:
            console.log(error.response)
            
    }
    // SEMPRE rejeita, inclusive em 401/403. Antes esses dois casos saíam pelo
    // `break` e a função retornava undefined, o que RESOLVE a promise com
    // undefined em vez de rejeitar — então todo `.then(res => res.data)` da app
    // estourava "Cannot read properties of undefined". O redirecionamento
    // continua acontecendo; o que muda é a promise não mentir que deu certo.
    return Promise.reject(error)
})


export const  get_all = async (endpoint, limit=10, offset=0, order_by=undefined, order=undefined, query="") => {
    const response = await api.post(endpoint, {limit, offset, order_by, order, query})
    //await new Promise(r => setTimeout(r, 2000));
    return response
}

export const  get_one = async (endpoint, id) => {
    const response = await api.get(endpoint+"/"+id)
    return response
}

export const  create = async (endpoint, data) => {
    const response = await api.post(endpoint, data)
    return response
}

export const  update = async (endpoint, id, data) => {
    const response = await api.put(endpoint+"/"+id, data)
    return response
}

export const delete_one = async (endpoint, id) => {
    const response = await api.delete(endpoint+"/"+id)
    return response
}

export const action = async (endpoint, id, suffix, body = undefined) => {
    const path = id != null ? `${endpoint}/${id}/${suffix}` : `${endpoint}/${suffix}`
    const response = await api.post(path, body ?? {})
    return response
}